module.exports = __webpack_public_path__ + "img/zhineng.3daf129a.png";